// extracted by mini-css-extract-plugin
module.exports = {"content":"ReviewContent_content__AaY_6"};